import { getEntityRef } from "@client/content/lib/helper";
import { type ModuleApiInfo } from "@client/content/selectors";
import { FormModalControlled, type FormModalControlledRenderParams } from "@client/controls/Modal/Modals/Form/component";
import { unwrapResponse } from "@client/lib/api";
import { type EntityRef } from "@client/types";
import SubmitButton from "@common/controls/Form/Buttons/Submit";
import { FormButtons } from "@common/controls/Form/component";
import { getDialCode } from "@common/controls/Inputs/PhoneInput/lib";
import { useI18n } from "@common/hooks/i18n";
import * as React from "react";
import api from "../../api";
import { type Leaderboard } from "../../types";
import ProfileFields from "../ProfileFields/container";

export type MapProps = EntityRef & {
  apiInfo: ModuleApiInfo;
  countryCode: string | null;
  launchId: string;
  isVisible: boolean;
};

export interface ActionProps {
  onClose: () => void;
  onSubmitted: (data: Leaderboard.Api.LaunchLeadboardItem) => void;
}

export default (props: ActionProps & MapProps) => {
  const i18n = useI18n();

  const submit = React.useCallback(
    async (data: Leaderboard.View.UserData) => {
      const res = await api.apply(props.apiInfo, {
        launchId: props.launchId,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        user: data
      });
      props.onSubmitted(unwrapResponse(res));
    },
    [props.apiInfo, props.onSubmitted]
  );

  const defaultValues = React.useMemo(
    (): Partial<Leaderboard.View.UserData> => ({
      telephone: getDialCode(props.countryCode) ?? undefined
    }),
    [props.countryCode]
  );

  return (
    <FormModalControlled
      className="cartly_content_leaderboard_vote first"
      defaultValues={defaultValues}
      isInViewport
      isVisible={props.isVisible}
      preventCloseWhenSubmitting
      title={i18n.apply}
      submit={submit}
      width={500}
      onClose={props.onClose}
    >
      {({ values }: FormModalControlledRenderParams<Leaderboard.View.UserData>) => (
        <>
          <ProfileFields {...getEntityRef(props)} values={values} />

          <FormButtons>
            <SubmitButton>{i18n.apply}</SubmitButton>
          </FormButtons>
        </>
      )}
    </FormModalControlled>
  );
};
